import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, ViewChild, ElementRef, ViewChildren } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { maxLenghtValidator } from '../../../validators/max-length.validator';
import * as moment from 'moment';
import { CommonService } from 'src/app/core/providers/forms/common.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Numbers } from 'src/app/utils/constants';

@Component({
  selector: 'app-insured-list-data',
  templateUrl: './insured-list-data.component.html',
  styleUrls: ['./insured-list-data.component.scss']
})
export class InsuredListDataComponent implements OnInit, OnDestroy {

  /**
   * @description Es el formulario
   */
  @Input() FORM_DATA: FormGroup;

  /**
   * @description Es la configuracion del formulario
   */
  @Input() FORM_CONFIG_FULL: any;
  @Input() FORM_CONFIG: any;

  /**
   * @description Es el paso del formulario
   */
  @Input() STEP: any;

  @Output() CLICK_BTN: EventEmitter<'back' | 'next'> = new EventEmitter();
  @ViewChildren('input') formValue: any;

  insureSelected: string;
  finish = new Subject();
  insuredListDataFormArr: FormArray;
  firstFormConfig: any;
  currentStep = 0;
  insured70 = 0;
  insuredSport = 0;
  /**
   * Número de asegurados mayores de 70 años (o 60, según el tipo de seguro).
   * Se usa para mostrar el calendario especial para mayores.
   * Calculado en ngOnInit a partir del formulario.
   */
  ac70 = 0;
  /**
   * Número total de asegurados que son mayores de 70/60 años más los que practican deportes de riesgo.
   * Se usa para mostrar el calendario de deportes a los siguientes asegurados después de los mayores.
   * Calculado en ngOnInit como la suma de ac70 y asegurados deportivos.
   */
  acS = 0;
  patternEmail: RegExp = this.commons.patternsForm('email');
  patternPassport: RegExp = this.commons.patternsForm('passport');
  typeDocChange: { name: string, value: any };
  docNumberChange: { name: string, value: any };
  typeBorn = 'mayor70';
  //#region Constructor
  /**
   * @ignore
   */
  constructor(
    private commons: CommonService,
    private gtmService: GoogleTagManagerService
  ) {
    this.commons = commons;
    this.gtmService = gtmService;
  }
  /**
   *  @ignore
   */
  ngOnInit() {
    this.currentStep = this.STEP;
    this.getProductChoosed();
    let insured70: any;
    if (this.insureSelected === 'incomingStudentsTravelAsistance') {
      this.typeBorn = 'mayor60';
      insured70 = this.FORM_DATA.get(this.FORM_CONFIG_FULL.insuredOlderThan60years.linkFormPath).value;
    } else {
      this.typeBorn = 'mayor70';
      insured70 = this.FORM_DATA.get(this.FORM_CONFIG_FULL.insuredOlderThan70years.linkFormPath).value;
    }
    const insuredSport: any = this.FORM_DATA.get(this.FORM_CONFIG_FULL.insuredsPlayRiskSports.linkFormPath).value;
    this.insured70 = 0;
    if (insured70.id !== undefined) { this.insured70 = insured70.id; }
    this.insuredSport = 0;
    if (insuredSport.id !== undefined) { this.insuredSport = insuredSport.id; }
    this.ac70 = this.insured70;
    this.acS = this.insured70 + this.insuredSport;
    this.initObsForm();
    window.scrollTo(0, 0);
  }
  /**
   *  @ignore
   */
  ngOnDestroy() {
    this.finish.next(true);
  }

  /**
   * @description Definición inicial del paso
   */
  initObsForm(): void {
    if (this.FORM_DATA) {
      this.setValidator();

      this.insuredListDataFormArr = (this.FORM_DATA.get(this.FORM_CONFIG.linkFormPath) as FormArray);
      this.FORM_DATA.get(this.FORM_CONFIG.linkFormPath).valueChanges.pipe(
        takeUntil(this.finish),
        tap(dat => {
          this.insuredListDataFormArr = dat;
        })
      ).subscribe();
    }
  }

  /**
   * @description asignar las validaciones del paso
   */
  public setValidator(): void {
    const baseForm: string = this.FORM_CONFIG.linkFormPath[0];
    const baseForm2: string = this.FORM_CONFIG.linkFormPath[1];
    const res: AbstractControl = this.FORM_DATA.get(this.FORM_CONFIG.linkFormPath);

    // tslint:disable-next-line: no-string-literal
    res['controls'].forEach((row: Array<any>, index: any) => {
      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentType']).setValidators([Validators.required]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentNumber'])
      .setValidators([maxLenghtValidator(Numbers.number15), Validators.required]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'name']).setValidators([Validators.required]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'firstSurname']).setValidators([Validators.required]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'dateBorn']).setValidators([Validators.required]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'email']).setValidators([Validators.pattern(this.patternEmail)]);

      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentType']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentNumber']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'name']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'firstSurname']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'dateBorn']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'email']).updateValueAndValidity();
    });
  }
  /**
   * @description Recupera el tipo de tomador: Particular o Empresa
   */
  getTypeOwner(): 'Particular' | 'Empresa' {
    if (this.FORM_DATA) {
      return this.FORM_DATA.get(this.FORM_CONFIG_FULL.insuredData.typeOwner.linkFormPath).value;
    }
  }
  /**
   * @description Recupera el tipo de formulario
   */
  getProductChoosed(): void {
    if (this.FORM_DATA) {
      this.insureSelected = this.FORM_CONFIG.linkFormPath[0];
    }
  }
  /**
   * @description botón siguiente o anterior
   */
  public clickButton(ev: 'back' | 'next'): void {
    if (ev === 'next') {
      this.datalayer();
      this.CLICK_BTN.emit(ev);
    } else {
      this.removeValidator();
      this.CLICK_BTN.emit(ev);
    }
  }

  /**
   * @description remover las validaciones del paso
   */
  public removeValidator(): void {
    const baseForm: string = this.FORM_CONFIG.linkFormPath[0];
    const baseForm2: string = this.FORM_CONFIG.linkFormPath[1];
    const res: AbstractControl = this.FORM_DATA.get(this.FORM_CONFIG.linkFormPath);
    // tslint:disable-next-line: no-string-literal
    res['controls'].forEach((row: Array<any>, index: any) => {
      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentType']).clearValidators();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentNumber']).clearValidators();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'name']).clearValidators();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'firstSurname']).clearValidators();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'dateBorn']).clearValidators();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'email']).clearValidators();

      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentType']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentNumber']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'name']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'firstSurname']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'dateBorn']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'email']).updateValueAndValidity();
    });
  }
  /**
   * @description Devuelve los valores del formulario
   */
  getFormValue(prop: string[]): AbstractControl {
    if (this.FORM_DATA) {
      const res: AbstractControl = this.FORM_DATA.get(prop);
      return res;
    }
  }
  /**
   * @description Devuelve los controls del formulario
   */
  getFormValueControls(prop: string[]): AbstractControl[] {
    if (this.FORM_DATA) {
      const res: any = this.FORM_DATA.get(prop);
      return res.controls;
    }
  }
  /**
   * @description Devuelve los valores informados en el tomador y los asigna al asegurado
   */
  setInsureSameOfOwner(): void {
    if (this.FORM_DATA && this.FORM_CONFIG && this.FORM_CONFIG_FULL && this.insuredListDataFormArr) {
      const values: any = {
        documentType: this.FORM_DATA.get(this.FORM_CONFIG_FULL.insuredData.documentType.linkFormPath).value,
        documentNumber: this.FORM_DATA.get(this.FORM_CONFIG_FULL.insuredData.documentNumber.linkFormPath).value,
        name: this.FORM_DATA.get(this.FORM_CONFIG_FULL.insuredData.particular.name.linkFormPath).value,
        firstSurname: this.FORM_DATA.get(this.FORM_CONFIG_FULL.insuredData.firstSurname.linkFormPath).value,
        secondSurname: this.FORM_DATA.get(this.FORM_CONFIG_FULL.insuredData.secondSurname.linkFormPath).value
      };
      // this.insuredListDataFormArr.at( 0 ).reset( values );
      const baseForm: string = this.FORM_CONFIG.linkFormPath[0];
      const baseForm2: string = this.FORM_CONFIG.linkFormPath[1];

      this.FORM_DATA.get([baseForm, baseForm2, 0, 'documentType']).setValue(
        { name: values.documentType.name, id: values.documentType.id });
      this.FORM_DATA.get([baseForm, baseForm2, 0, 'documentNumber']).setValue(values.documentNumber);
      this.FORM_DATA.get([baseForm, baseForm2, 0, 'name']).setValue(values.name);
      this.FORM_DATA.get([baseForm, baseForm2, 0, 'firstSurname']).setValue(values.firstSurname);
      this.FORM_DATA.get([baseForm, baseForm2, 0, 'secondSurname']).setValue(values.secondSurname);
      this.typeDocChange = { name: 'typeDoc', value: values.documentType };
    }
  }

  /**
   * @description asignar las validaciones y valores para los nuevos campos desde el excel
   */
  setInsuredList(data: any): void {
    const baseForm: string = this.FORM_CONFIG.linkFormPath[0];
    const baseForm2: string = this.FORM_CONFIG.linkFormPath[1];
    const typeDocument: { name: string, id: number }[] = [{ name: 'NIF', id: Numbers.number1 },
    { name: 'CIF', id: Numbers.number2 },
    { name: 'NIE', id: Numbers.number3 },
    { name: 'Pasaporte', id: Numbers.number4 }];

    data.forEach((row: Array<any>, index) => {
      // El documento está bien formado, seteamos los campos en el formulario
      row[Numbers.number5] = row[Numbers.number5].replace(/['"]+/g, '');
      const fecha: Date = moment(row[Numbers.number5], 'DD-MM-YYYY').toDate();
      const fechaMom: string = moment(fecha).format('DD/MM/YYYY');
      const documentFile: { name: string; id: number; } = typeDocument.find((el) => el.id === row[Numbers.number3]);

      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentType']).setValidators([Validators.required]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentNumber'])
      .setValidators([maxLenghtValidator(Numbers.number15), Validators.required]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'name']).setValidators([Validators.required]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'firstSurname']).setValidators([Validators.required]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'dateBorn']).setValidators([Validators.required]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'email']).setValidators([Validators.pattern(this.patternEmail)]);

      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentType']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentNumber']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'name']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'firstSurname']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'dateBorn']).updateValueAndValidity();
      this.FORM_DATA.get([baseForm, baseForm2, index, 'email']).updateValueAndValidity();

      this.FORM_DATA.get([baseForm, baseForm2, index, 'name']).setValue(row[0]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'firstSurname']).setValue(row[Numbers.number1]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'secondSurname']).setValue(row[Numbers.number2]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentType']).setValue({ name: documentFile.name, id: documentFile.id });
      this.FORM_DATA.get([baseForm, baseForm2, index, 'documentNumber']).setValue(row[Numbers.number4]);
      this.FORM_DATA.get([baseForm, baseForm2, index, 'dateBorn']).setValue(fechaMom);
      this.typeDocChange = { name: 'typeDoc', value: documentFile };
    });

    this.formValue.nativeElement.click();
  }

  /**
   * @description validar el tipo de documento
   */
  checkDocumentNumber(val: any, type: any): void {
    const auxValue: any = val;
    const auxValueLength: any = val.length;
    this.docNumberChange = { name: '', value: '' };
    if (auxValueLength < Numbers.number9) {
      // error
      this.docNumberChange = { name: 'docNumber', value: 'error' };
    } else {
      switch (type.name) {
        case ('NIF' || 'DNI' || 'NIE'):
          const auxValidateNIF: boolean = this.commons.validateDNI(auxValue);
          this.docNumberChange = { name: 'docNumber', value: 'error' };
          if (auxValidateNIF) { this.docNumberChange = { name: 'docNumber', value: 'valid' }; }
          break;
        case 'Pasaporte':
          // const auxValidatePass = this.commons.validatePassport( auxValue );
          const auxValidatePass: boolean = this.patternPassport.test(auxValue);
          this.docNumberChange = { name: 'docNumber', value: 'error' };
          if (auxValidatePass) { this.docNumberChange = { name: 'docNumber', value: 'valid' }; }
          break;
        case 'CIF':
          const auxValidateCIF: boolean = this.commons.validateCif(auxValue);
          this.docNumberChange = { name: 'docNumber', value: 'error' };
          if (auxValidateCIF) { this.docNumberChange = { name: 'docNumber', value: 'valid' }; }
          break;
        default:
          break;
      }
    }
  }

  /**
   * @description asignar evento analítica
   */
  datalayer(): void {
    const formName: any = this.FORM_DATA.get('insureSelected').value;
    const datalayerD: any = {
      event: 'ev_tarificacion',
      event_category: 'tarificacion',
      event_action: formName.layerName,
      event_label: 'gestion_de_polizas',
      categoria_seguro: 'viajes',
      paso: 't4'
    };
    this.gtmService.pushTag(datalayerD);
  }

  /**
   * Transform the email to lowerCase
   */
  transformLower(index: number): void {
    const baseForm: string = this.FORM_CONFIG.linkFormPath[0];
    const baseForm2: string = this.FORM_CONFIG.linkFormPath[1];

    const LOWER: string = this.FORM_DATA.get([baseForm, baseForm2, index, 'email']).value.toString().toLowerCase();
    this.FORM_DATA.get([baseForm, baseForm2, index, 'email']).setValue(LOWER);
  }

}
